import React from "react";

import { useTranslation } from "react-i18next";

import ProvincePicker from "@/components/ProvincePicker";

import styles from "./styles.module.css";

type IntroViewProps = {
  fetchNextEvent: (province: string) => Promise<void>;
  loadingEvent: string | null;
};

const IntroView = ({ fetchNextEvent, loadingEvent }: IntroViewProps) => {
  const { t } = useTranslation();

  return (
    <div className="pb-[60px]">
      <h2
        className="text-xl uppercase text-center font-black mt-[30px]"
        dangerouslySetInnerHTML={{ __html: t("signup.heading") }}
      />
      <div
        className="mt-[15px] mx-4 text-center text-[14px] line-height-[120%] font-light text-ford-blue"
        dangerouslySetInnerHTML={{ __html: t("signup.text") }}
      />

      <div className="flex justify-center px-[15px]">
        <div className="mt-[30px] bg-[#F0F0F0] rounded-[30px] px-[15px] py-[30px] max-w-[360px]">
          <h2 className="text-xl text-[#1700F4] uppercase text-center font-black mb-5">
            {t("intro.prizeTitle")}
          </h2>
          <ul className="list-disc text-xs flex flex-col gap-[10px] italic text-[12px] text-[#444] pl-4">
            <li>
              <span className="d-block">
                {t("intro.prizeText1")} {t("intro.prizeText1Cars")}
              </span>
            </li>
            <li
              dangerouslySetInnerHTML={{
                __html: t("intro.prizeText2"),
              }}
            />
            <li
              dangerouslySetInnerHTML={{
                __html: t("intro.prizeText3"),
              }}
            />
          </ul>
        </div>
      </div>

      <p
        className={`font-roboto text-[10px] text-left text-[#666] mt-[30px] mx-1 text-center no-hyphen-break break-keep ${styles.mobileNote}`}
        dangerouslySetInnerHTML={{ __html: t("intro.note") }}
      />

      <ProvincePicker
        setProvince={fetchNextEvent}
        loadingEvent={loadingEvent}
        notFound={false}
      />
    </div>
  );
};

export default IntroView;
